var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastPray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42871 1.57141V2.71427",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8574 2.71425L12.4289 2.14282",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00014 2.71425L4.42871 2.14282",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8567 16.4286H13.1744C12.0335 16.4287 10.9338 16.0022 10.0914 15.2329C9.24889 14.4636 8.72452 13.407 8.62127 12.2708L8.48984 10.824C8.47119 10.6201 8.51093 10.4151 8.60442 10.233C8.69792 10.0509 8.84131 9.8991 9.01784 9.79542C9.16884 9.7066 9.33919 9.65589 9.51417 9.64767C9.68916 9.63945 9.86352 9.67397 10.0222 9.74823C10.1808 9.8225 10.319 9.93428 10.4248 10.0739C10.5306 10.2136 10.6007 10.3769 10.6293 10.5497L10.9424 12.4286",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.857 12.4252H14.001C13.7239 12.4254 13.4561 12.3249 13.2476 12.1424C13.039 11.9599 12.9039 11.7078 12.8673 11.4332L12.1496 6.04344C12.1196 5.81955 12.0316 5.60739 11.8943 5.42803C11.757 5.24868 11.5752 5.10836 11.3669 5.02101C11.1585 4.93367 10.931 4.90234 10.7068 4.93013C10.4827 4.95792 10.2697 5.04387 10.089 5.17944C9.76329 5.42401 9.57129 5.80801 9.57129 6.21487V9.56801",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.4286H3.68229C4.82317 16.4287 5.92286 16.0022 6.76533 15.2329C7.60781 14.4636 8.13218 13.407 8.23543 12.2708L8.36686 10.824C8.38551 10.6201 8.34577 10.4151 8.25227 10.233C8.15878 10.0509 8.01539 9.8991 7.83886 9.79542C7.68786 9.7066 7.51751 9.65589 7.34252 9.64767C7.16754 9.63945 6.99318 9.67397 6.83452 9.74823C6.67586 9.8225 6.53768 9.93428 6.4319 10.0739C6.32613 10.2136 6.25595 10.3769 6.22743 10.5497L5.91429 12.4286",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.4239H2.856C3.13312 12.4242 3.40088 12.3237 3.60943 12.1412C3.81799 11.9587 3.95313 11.7066 3.98971 11.4319L4.70743 6.04338C4.73721 5.81939 4.82509 5.6071 4.96233 5.42759C5.09956 5.24809 5.28139 5.10762 5.48972 5.02015C5.69806 4.93268 5.92566 4.90125 6.14991 4.92898C6.37416 4.95671 6.58725 5.04264 6.768 5.17823C7.09371 5.42281 7.28571 5.80681 7.28571 6.21366V9.5668",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastPray);
export default __webpack_public_path__ + "static/media/toast-pray.a5a3b4545e4f4de262c102266b0d6639.svg";
export { ForwardRef as ReactComponent };